import styled from '@emotion/styled';

const Tr = styled.tr(props => ({
  display: props.display || 'table-row',
}))

export default Tr;
